<template>
   <div v-if="this.usuarios.userInfo" class="grupo container mb-6" style="max-width: 350px; position: fixed; top: -4px; right: 90px; z-index: 999">
      <label for="nome">Grupo</label>
      <Dropdown
         id="cargo"
         style="margin-left: 10px; width: 400px"
         v-model="grupoSelecionado"
         :options="gruposUsuario"
         :filter="true"
         optionLabel="descricao"
         optionValue="gestorId"
         placeholder="Grupos"
         @change="recarregar()"
      />
   </div>
</template>
<script src="./drop-grupo-usuario.js"></script>
